import React from 'react'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../components/Form/Field'
import MultiSelectBox from '../../../../../../features/components/Form/MultiSelectBox'

import { DIGITAL_STRENGTHS, RH_PLATFORMS } from '../../../fields'
import { preferredChannelsOptions } from '../../../../../ChatPage/SponsorInfoDrawer/SponsorInfoForm/fields'
import useCommonStyles from '../../../../../../styles/common/listPage'

const DigitalStrengthAndPlatformsRow = ({ formik }) => {
  const commonClasses = useCommonStyles()
  const { values, setFieldValue } = formik

  const { t } = useTranslation()

  return (
    <div className={commonClasses.formRow}>
      <FieldLabelWrapper label={t('Digital strength')} labelFor={DIGITAL_STRENGTHS}>
        <Field
          placeholder={'Digital strengths'}
          formik={formik}
          name={DIGITAL_STRENGTHS}
          enableReinitialize
          autoComplete="off"
          isTextarea={true}
          minRows={2}
        />
      </FieldLabelWrapper>
      <FieldLabelWrapper label={t('Platforms')} labelFor={RH_PLATFORMS}>
        <MultiSelectBox
          name={RH_PLATFORMS}
          value={values[RH_PLATFORMS]}
          setFieldValue={setFieldValue}
          enableReinitialize
          autoComplete="off"
          placeholder={t('Select platforms')}
          options={preferredChannelsOptions}
        />
      </FieldLabelWrapper>
    </div>
  )
}

export default DigitalStrengthAndPlatformsRow
